// AI-CONTEXT: See docs/features/livereport2-period-selector.md
//
// Period-filters the question-response rows in an exportTemplateData blob.
// All question-type template rendering (TemplateIndicatorChart, useMatrixData)
// reads from `data.effects.responses`, so filtering this one array — and
// passing the filtered copy down — periodises every indicator chart without
// touching the leaf components. The blob itself is shared and never mutated.

import filterRowsByPeriod from './filterRowsByPeriod'

/**
 * @template T
 * @param {T} templateData - The exportTemplateData blob (or null when not in template mode)
 * @param {{start: string|null, end: string|null}|null} range - Resolved period (ISO dates), null = no filter
 * @returns {T} A copy with `data.effects.responses` filtered, or the input when nothing to do
 */
const filterTemplateEffectsResponses = (templateData, range) => {
    if (!templateData) return templateData
    if (!range || (!range.start && !range.end)) return templateData

    const data = /** @type {any} */ (templateData).data || {}
    const effects = data.effects || {}

    return {
        ...templateData,
        data: {
            ...data,
            effects: {
                ...effects,
                responses: filterRowsByPeriod(effects.responses || [], range),
            },
        },
    }
}

export default filterTemplateEffectsResponses
